import { ref } from "vue";
import { defineStore } from "pinia";
import type { QATypes } from "@/types/qaItems";
export const useQAInfoStore = defineStore("qaInfo", () => {
  // 记录对话id
  const conversationId = ref<string>("");
  const setConversationId = (id: string) => {
    conversationId.value = id;
  };

  // 问答列表，这里所有输入输出都记录
  const qaList = ref<QATypes[]>([]);
  const addQA = (qa: QATypes) => {
    qaList.value.push(qa);
  };
  const clearQA = () => {
    qaList.value = [];
  };

  // 记录当前问题的id，用于判断以前的问题不让点击
  const questionId = ref<string>("");
  const setQuestionId = (id: string) => {
    questionId.value = id;
  };
  // 选项选择临时记录
  const selectTempList = ref<any[]>([]);
  const addSelectTemp = (select: any) => {
    selectTempList.value.push(select);
  };
  const clearSelectTemp = () => {
    selectTempList.value = [];
  };

  const clearAll = () => {
    clearSelectTemp();
    clearQA();
    setConversationId("");
  };
  return {
    questionId,
    qaList,
    selectTempList,
    conversationId,
    setConversationId,
    setQuestionId,
    addQA,
    clearQA,
    addSelectTemp,
    clearSelectTemp,
    clearAll,
  };
});
